export default "__VITE_ASSET__BhTk_5XV__"